goog.module('yext.location.GoogleRelationship');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Select = goog.require('yext.location.Select');

/**
 * Models a Google Relationship field
 *
 * @constructor
 * @param {!jQuery} $editCtx - field edit DOM
 * @param {!jQuery} $displayCtx - field display DOM
 *
 * @author Oscar Li (oscar@yext.com)
 */
const GoogleRelationship = function($editCtx, $displayCtx) {
  this.$editCtx = $editCtx;
  this.$displayCtx = $displayCtx;

  this.$searchContainer = $editCtx.find('.js-search-container');
  this.$googlePlaceContainer = $editCtx.find('.js-edit-display');
  this.type = new Select($editCtx.find('.js-relationship-type'));

  this.$nameDisplay = $displayCtx.find('.js-google-name');
  this.$address1Display = $displayCtx.find('.js-google-address1');
  this.$cityDisplay = $displayCtx.find('.js-google-city');
  this.$regionDisplay = $displayCtx.find('.js-google-region');
  this.$countryDisplay = $displayCtx.find('.js-google-country');
  this.$postalCodeDisplay = $displayCtx.find('.js-google-postalCode');
  this.$idDisplay = $displayCtx.find('.js-place-id-content');

  this.$nameEdit = $editCtx.find('.js-google-name');
  this.$address1Edit = $editCtx.find('.js-google-address1');
  this.$cityEdit = $editCtx.find('.js-google-city');
  this.$regionEdit = $editCtx.find('.js-google-region');
  this.$countryEdit = $editCtx.find('.js-google-country');
  this.$postalCodeEdit = $editCtx.find('.js-google-postalCode');
  this.$idEdit = $editCtx.find('.js-place-id-content');

  this.storedValue = {};
  this.storeValue_();
  this.updateGooglePlaceInputWithStoredValue_(this.storedValue);

  this.autocomplete = this.initAutocomplete_();
  this.autocomplete.addListener('place_changed', this.updateAddress_.bind(this));

  this.bindRemoveIcon_();
  this.bindType_();
  if (this.storedValue.indeterminate) {
    this.bindResetAll_();
  }
};

/**
 * Store the current values
 *
 * @private
 */
GoogleRelationship.prototype.storeValue_ = function() {
  this.storedValue = {
    name: this.$nameEdit.text(),
    address1: this.$address1Edit.text(),
    city: this.$cityEdit.text().replace(/,\s*$/, ''), // remove trailing whitespace and comma
    region: this.$regionEdit.text().trim(), // remove trailing whitespace
    country: this.$countryEdit.text(),
    postalCode: this.$postalCodeEdit.text(),
    id: this.$idEdit.text(),
    type: this.type.getValue(),
    indeterminate: this.$editCtx.find('.js-field-indeterminate').val() === 'true',
  };
};

/**
 * Initializes Google Place autocomplete functionality for search bar
 *
 * @private
 */
GoogleRelationship.prototype.initAutocomplete_ = function() {
  return new google.maps.places.Autocomplete(
    this.$editCtx.find('.js-search')[0],
    {types: ['establishment']});
};

/**
 * Gets the user selected Google Place and updates the UI
 *
 * @private
 */
GoogleRelationship.prototype.updateAddress_ = function() {
  this.hideAndClearSearch_();

  var place = this.autocomplete.getPlace();

  // We don't need to do anything if the user selects the original Google Place
  if (place.place_id === this.storedValue.id) {
    this.$googlePlaceContainer.show();
    return;
  }

  var $googleAddress = $($.parseHTML('<div>' + place.adr_address + '</div>'));
  var googlePlace = {};
  googlePlace.address1 = $googleAddress.find('.street-address').text();
  googlePlace.city = $googleAddress.find('.locality').text();
  googlePlace.region = $googleAddress.find('.region').text();
  googlePlace.postalCode = $googleAddress.find('.postal-code').text();
  googlePlace.country = $googleAddress.find('.country-name').text();
  googlePlace.id = place.place_id;
  googlePlace.name = place.name;
  this.renderEditView_(googlePlace);

  this.$googlePlaceContainer.show();

  this.updateGooglePlaceInputWithStoredValue_(googlePlace);

  $(this).trigger('updated');
};

/**
 * @private
 * When a user clicks on the remove icon, shows the Google Place search bar
 * and hides the current address and Google Place Id
 */
GoogleRelationship.prototype.bindRemoveIcon_ = function() {
  this.$editCtx.find('.js-remove-item').click(function() {
    this.$googlePlaceContainer.hide();
    this.$searchContainer.find('.js-search').val('');
    this.$searchContainer.show();
  }.bind(this));
};

/**
 * When a user selects a new relationship type from the dropdown
 *   (1) if the type is not UNSPECIFIED and the original type was 'UNSPECIFIED' and the
         user hasn't selected a Google Place yet, show the search bar
 *   (2) else if the type is UNSPECIFIED, hide the address, place id, and search bar and trigger
 *       an update message
 *   (3) else show the search bar if the google place container is not visible and trigger an
         update message
 *
 * @private
 */
GoogleRelationship.prototype.bindType_ = function() {
  $(this.type).on('updated', function() {
    if (this.storedValue.type === 'UNSPECIFIED'
        && this.type.getValue() !== 'UNSPECIFIED'
        && !this.$googlePlaceContainer.is(':visible')) {
      this.$searchContainer.show();
    } else if (this.type.getValue() === 'UNSPECIFIED') {
      this.$googlePlaceContainer.hide();
      this.updateGooglePlaceInputWithStoredValue_({});
      this.hideAndClearSearch_();
      $(this).trigger('updated');
    } else {
      if (!this.$googlePlaceContainer.is(':visible')) {
        this.$searchContainer.show();
      }
      $(this).trigger('updated');
    }
  }.bind(this));
};

/**
 * When a user clicks on the 'Reset All' button while editing an indeterminate
 * Google Entity Relationship field, shows the normal edit UI and hides the indeterminate
 * edit UI.
 *
 * @private
 */
GoogleRelationship.prototype.bindResetAll_ = function() {
  this.$editCtx.find('.js-reset-all').on('click', function() {
    this.$editCtx.find('.js-indeterminate-content').hide();

    this.$editCtx.find('.js-content').show();
    if (!this.storedValue.id) {
      this.$googlePlaceContainer.hide();
    }
  }.bind(this));
};

/**
 * Resets the field to its original state
 */
GoogleRelationship.prototype.reset = function() {
  this.renderEditView_(this.storedValue);
  this.hideAndClearSearch_();
  this.type.set({'value': this.storedValue.type});
  this.updateGooglePlaceInputWithStoredValue_(this.storedValue);

  if (this.storedValue.id && this.storedValue.type != 'UNSPECIFIED') {
    this.$googlePlaceContainer.show();
  } else {
    this.$googlePlaceContainer.hide();
  }

  if (this.storedValue.indeterminate) {
    this.$editCtx.find('.js-indeterminate-content').show();
    this.$editCtx.find('.js-content').hide();
  }
  this.$searchContainer.hide();
};

/**
 * @private
 * Clears the Google Place search bar and hides it
 */
GoogleRelationship.prototype.hideAndClearSearch_ = function() {
  this.$searchContainer.find('.js-search').val('');
  this.$searchContainer.hide();
};

/**
 * Updates edit view from response
 *
 * @param {!Object} response - JSON response from server after saving edit
 */
GoogleRelationship.prototype.updateEditViewFromResponse = function(response) {
  // don't update the field when suggesting an edit
  if (response.suggestedEditIds || (response.metadata && response.metadata.suggestedEditIds)) {
    return;
  }

  response = response.field ? response.field : response;

  this.storedValue = {
    name: response.place ? response.place.name : '',
    address1: response.place ? response.place.address1 : '',
    city: response.place ? response.place.city : '',
    region: response.place ? response.place.region : '',
    country: response.place ? response.place.country : '',
    postalCode: response.place ? response.place.postalCode : '',
    id: response.place ? response.place.id : '',
    type: response.options.value,
    indeterminate: false,
  };
  for (var property in this.storedValue) {
    if (this.storedValue[property] === null || this.storedValue[property] === null) {
      delete this.storedValue[property];
    }
  }

  this.updateGooglePlaceInputWithStoredValue_(this.storedValue);
  this.$editCtx.find('.js-field-timestamp').val(response.timestamp);
  this.renderEditView_(this.storedValue);
};

/**
 * Updates display view from response
 *
 * @param {!Object} response - JSON response from server after saving edit
 */
GoogleRelationship.prototype.updateDisplayViewFromResponse = function(response) {
  // don't update the field when suggesting an edit
  if (response.suggestedEditIds || (response.metadata && response.metadata.suggestedEditIds)) {
    return;
  }

  response = response.field ? response.field : response;

  this.$displayCtx.find('.js-emptyvalue').hide();
  this.$displayCtx.find('.js-various').hide();
  this.$displayCtx.find('.js-relationship-container').hide();

  // Setting the type to "Unspecified" clears the field
  if (response['options']['value'] === 'UNSPECIFIED') {
    this.$displayCtx.find('.js-emptyvalue').show();
    return;
  }

  this.$displayCtx.find('.js-relationship-container').show();
  this.renderDisplayView_(response['place'], response['type']);
};

/**
 * Renders the edit UI
 *
 * @private
 * @param {!Object} data - contains address fields to render
 */
GoogleRelationship.prototype.renderEditView_ = function(data) {
  this.$nameEdit.text(data.name ? data.name : '');
  this.$address1Edit.text(data.address1 ? data.address1 : '');
  this.$cityEdit.text(data.city ? data.city + ', ' : '');
  this.$regionEdit.text(data.region ? data.region + ' ' : '');
  this.$countryEdit.text(data.country ? data.country : '');
  this.$postalCodeEdit.text(data.postalCode ? data.postalCode : '');
  this.$idEdit.text(data.id ? data.id : '');
};

/**
 * Renders the display UI
 *
 * @private
 * @param {!Object} data - contains address fields to render
 * @param {string} type - relationship type
 */
GoogleRelationship.prototype.renderDisplayView_ = function(data, type) {
  this.$displayCtx.find('.js-relationship-type').text(type);

  this.$nameDisplay.text(data.name ? data.name : '');
  this.$address1Display.text(data.address1 ? data.address1 : '');
  this.$cityDisplay.text(data.city ? data.city + ', ' : '');
  this.$regionDisplay.text(data.region ? data.region + ' ' : '');
  this.$countryDisplay.text(data.country ? data.country : '');
  this.$postalCodeDisplay.text(data.postalCode ? data.postalCode : '');
  this.$idDisplay.text(data.id ? data.id : '');
};

/**
 * Updates the Google Place hidden input
 *
 * @private
 * @param {!Object} value - value to update the input with
 */
GoogleRelationship.prototype.updateGooglePlaceInputWithStoredValue_ = function(value) {
  this.$editCtx.find('.js-field-place').val(yext.JSON.stringify(value));
};

exports = GoogleRelationship;
